export default "__VITE_ASSET__C$Gr7NM$__"